import React from "react";
import InStock from "../Icons/InStock";
import LowStock from "../Icons/LowStock";
import NotAvailable from "../Icons/NotAvailable";
import OrderIn from "../Icons/OrderIn";
import Spinner from "../Spinner/Spinner";

const determinePillStyle = (availability) => {
  switch (availability) {
    case "IN_STOCK":
      return {
        style: "in-stock",
        text: "In Stock",
        icon: <InStock />,
      };
    case "LOW_STOCK":
      return {
        style: "low-stock",
        text: "Low Stock",
        icon: <LowStock />,
      };
    case "NO_LONGER_AVAILABLE":
      return {
        style: "not-available",
        text: "Not Available",
        icon: <NotAvailable />,
      };
    default:
    case "AVAILABLE_TO_ORDER":
      return {
        style: "order-in",
        text: "Available to Order In",
        icon: <OrderIn />,
      };
  }
};

const StockAvailabilityPill = ({
  stockAvailability,
  loading,
  stockError,
  isVisible,
}) => {
  if (!isVisible) {
    return null;
  }

  const stockPillStyle = determinePillStyle(
    !stockError ? stockAvailability : null
  );

  return (
    <div className="pdp-main-block__subsection">
      <div className="stock-availability-pill">
        {loading ? (
          <Spinner size="18px" />
        ) : (
          <label
            className={`label ${stockPillStyle.style}`}
            data-testid={"stock-availability-pill"}
          >
            {stockPillStyle.icon}
            <div className="label-text">{stockPillStyle.text}</div>
          </label>
        )}
      </div>
    </div>
  );
};

export default StockAvailabilityPill;
